module.exports = __webpack_public_path__ + "img/tooth11.331c9ece.png";